import React from 'react'
import { OeControlTestDetermination } from '@trustero/trustero-api-web/lib/artifact/artifact_pb'
import { SOURCE_RESULT } from '@trustero/trustero-api-web/lib/source/source_pb'
import { AuditScanResultType } from './AuditScanArtifact.types'
import {
  AuditScanControlFailIcon,
  AuditScanControlIncompleteIcon,
  AuditScanControlNotScannedIcon,
  AuditScanControlPassIcon,
  AuditScanControlTestFailIcon,
  AuditScanControlTestPassIcon,
  AuditScanControlTestUnknownXIcon,
} from './AuditScanArtifact.styles'

export const getSourceResultFromDetermination = (
  determination: OeControlTestDetermination,
): SOURCE_RESULT => {
  switch (determination) {
    case OeControlTestDetermination.PASS:
      return SOURCE_RESULT.PASS
    case OeControlTestDetermination.FAIL:
      return SOURCE_RESULT.FAIL
    case OeControlTestDetermination.INCOMPLETE:
    default:
      return SOURCE_RESULT.UNKNOWN
  }
}

export const getSourceResultFromExceptionsFound = (
  exceptionsFound: boolean,
): SOURCE_RESULT => {
  return exceptionsFound ? SOURCE_RESULT.FAIL : SOURCE_RESULT.PASS
}

export const getOESourceResultIcon = (result: SOURCE_RESULT): JSX.Element => {
  switch (result) {
    case SOURCE_RESULT.PASS:
      return <AuditScanControlTestPassIcon />
    case SOURCE_RESULT.FAIL:
      return <AuditScanControlTestFailIcon />
    default:
      return <AuditScanControlTestUnknownXIcon />
  }
}

export const getAuditScanResultIcon = (
  result: OeControlTestDetermination,
  resultType: AuditScanResultType,
): JSX.Element => {
  const isControlResult = resultType === AuditScanResultType.OVERALL
  switch (result) {
    case OeControlTestDetermination.PASS:
      return isControlResult ? (
        <AuditScanControlPassIcon />
      ) : (
        <AuditScanControlTestPassIcon />
      )
    case OeControlTestDetermination.FAIL:
      return isControlResult ? (
        <AuditScanControlFailIcon />
      ) : (
        <AuditScanControlTestFailIcon />
      )
    case OeControlTestDetermination.INCOMPLETE:
      return isControlResult ? (
        <AuditScanControlIncompleteIcon />
      ) : (
        <AuditScanControlTestUnknownXIcon />
      )
    default:
      return <AuditScanControlNotScannedIcon />
  }
}
